import React from 'react';
import { Link } from 'react-router-dom';
import { internalHref } from '../utils/internalHref';

interface EmbedLayoutProps {
  children: React.ReactNode;
  calculatorName: string;
  path: string;
}

const EmbedLayout: React.FC<EmbedLayoutProps> = ({ children, calculatorName, path }) => {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <main className="flex-grow p-4">
        {children}
      </main>
      <footer className="border-t border-gray-200 p-2 text-center text-sm text-gray-600">
        <Link 
          to={internalHref(path)}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-1 hover:text-blue-600 transition-colors"
        >
          {calculatorName} by Boat Calculators
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
            />
          </svg>
        </Link>
      </footer>
    </div>
  );
};

export default EmbedLayout;
